export default {
  //Состояние приложения
  // state: null, // TODO: ??? may be 'status'?

  // LOGO
  defaultLogo: {
    text: 'DMS',
    lineHeight: '48px',
    textAlign: 'center',

    fontFamily: 'Times New Roman',
    fontSize: '26px',
    bold: true,

    color: 'rgba(255, 255, 255, 0.85)',
    background: 'rgba(255, 255, 255, 0.25)',
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    
    width: '244px',
    height: '100%',
    maxHeight: '48px',
  },
  logo: {},
  
  defaultProfile: {
    first_name: '',
    last_name: '',
    middle_name: '',
    birthdate: '',
    gender: null,
    email: '',
    phone: '',
    image: '',
    confirmed_email: true,
    confirmed_phone: false
  },
  profile: {},
  
  //Token auxiliary params
  isTokenRefreshing: false,
  refreshingCall: undefined,
  
  //Идентификаторы
  auth_tokens: {},
  accountId: null,    //ID аккаунта
  companyId: null,    //ID компании
  departmentId: null, //ID подразделения
  postId: null,       //ID поста в компании
  isMyPost: true,
  
  anketaId: null,     //ID анкеты
  anketa: {},         // анкета
  
  //Список доступов
  accesses: [],

  //Список сервисов
  services: [],
  
  //Список компаний
  companies: [],

  // User sessions
  sessions: [],
  
  //Themes
  themes: [],
  
  defaultTheme: {
    themeContent: {
      iconColor: "#9e9e9e",
      panel: "#9e9e9e",
      primary: "#9e9e9e",
      secondary: "#9e9e9e",
      accent: "#9e9e9e",
      error: "#9e9e9e",
      warning: "#9e9e9e",
      info: "#9e9e9e",
      success: "#9e9e9e",
      topPanel: "#9e9e9e"
    },
    selected: false,
    name: "Стандартная",
    id: "default",
    system: true
  },
}



// WEBPACK FOOTER //
// ./src/apps/account/store/common/state.js